import api from '../../../../api/client'

function normalizeOptionsPayload(data) {
  if (Array.isArray(data)) return data
  if (Array.isArray(data?.items)) return data.items
  return []
}

export async function listTasks(params) {
  const { data } = await api.get('/tasks/', { params })
  return data
}

export async function getTaskDetail(taskId) {
  const { data } = await api.get(`/tasks/${taskId}`)
  return data
}

export async function createTask(payload) {
  const { data } = await api.post('/tasks/', payload)
  return data
}

export async function updateTask(taskId, payload) {
  const { data } = await api.put(`/tasks/${taskId}`, payload)
  return data
}

export async function validateTaskCompletion(taskId) {
  const { data } = await api.get(`/tasks/${taskId}/validate-completion`)
  return data // { valid: bool, errors: string[] }
}

export async function listTaskProjectOptions(params) {
  const { data } = await api.get('/projects/', { params })
  return normalizeOptionsPayload(data)
}

export async function listTaskUserOptions(params) {
  const normalizedPageSize = Math.min(Number(params?.page_size || 50), 200)
  const normalizedParams = { ...(params || {}), page_size: normalizedPageSize }
  const { data } = await api.get('/options/users', { params: normalizedParams })
  return normalizeOptionsPayload(data)
}

export async function fetchTaskOptionsPage(search, page, pageSize = 20) {
  const { data } = await api.get('/tasks/', {
    params: {
      page,
      page_size: pageSize,
      search: search || '',
      includeTotal: true,
      archive: false,
      fromDate: '1900-01-01',
      toDate: '9999-12-31',
    },
  })
  const raw = Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : []
  const items = raw.map((task) => ({
    value: String(task.id),
    label: task.task_name || task.task_code || `Task #${task.id}`,
    subLabel: task.task_code,
  }))
  const total = Number(data?.total ?? 0)
  const hasMore = total > 0 ? page * pageSize < total : items.length === pageSize
  return { items, hasMore }
}

export async function fetchTaskUserOptionsPage(search, page, pageSize = 20, projectId = null) {
  const normalizedPageSize = Math.min(Number(pageSize || 20), 200)
  const params = {
    page,
    page_size: normalizedPageSize,
    search: search || '',
  }
  if (Number(projectId) > 0) {
    params.project_id = Number(projectId)
  }
  const { data } = await api.get('/options/users', {
    params,
  })
  const raw = Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : []
  const items = raw.map((user) => ({
    value: String(user.id),
    label: user.name,
    subLabel: user.email,
  }))
  const total = Number(data?.total ?? 0)
  const hasMore = total > 0 ? page * normalizedPageSize < total : items.length === normalizedPageSize
  return { items, hasMore }
}

export async function fetchTaskProjectOptionsPage(search, page, pageSize = 20) {
  const { data } = await api.get('/projects/', {
    params: {
      page,
      page_size: pageSize,
      search: search || '',
      includeTotal: true,
      archive: false,
      fromDate: '1900-01-01',
      toDate: '9999-12-31',
    },
  })
  const raw = Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : []
  const items = raw.map((project) => ({
    value: String(project.id),
    label: project.name || `Project #${project.id}`,
  }))
  const total = Number(data?.total ?? 0)
  const hasMore = total > 0 ? page * pageSize < total : raw.length === pageSize
  return { items, hasMore }
}

export async function downloadTaskBulkTemplate() {
  const { data } = await api.get('/tasks/bulk-upload/template', {
    responseType: 'blob',
  })
  const blob = new Blob([data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'Task_Bulk_Upload_Template.xlsx')
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
  return data
}

export async function uploadTaskBulkExcel(file) {
  const formData = new FormData()
  formData.append('file', file)
  const { data } = await api.post('/tasks/bulk-upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data
}


